module.exports = __webpack_public_path__ + "img/Clear-field.99719d04.svg";